import React from "react";
import { Checkbox, Grid, IconButton, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Menu, Stack, TextField, Typography } from "@mui/material";
// import { blue, green, red, yellow, cyan } from '@mui/material/colors';
import { Edit, SettingsInputSvideoOutlined } from "@mui/icons-material";
import * as lstCor from '@mui/material/colors';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import Service from "../../util/Service";

const ITEM_HEIGHT = 48;
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};
const cc = ['blue', 'green', 'red', 'yellow', 'cyan'];

export default function EtiquetaMenu(props) {
    const { anchorEl, open, handleClose, kanban, cartao, action, TYPES } = props;

    const [colors, setColors] = React.useState();
    const [todas, setTodas] = React.useState([]);
    const [checked, setChecked] = React.useState([]);
    const [openModal, setOpenModal] = React.useState(false);
    const [cor, setCor] = React.useState();
    const [titulo, setTitulo] = React.useState('');
    // const [corEscolhida, setCorEscolhida] = React.useState();

    // const handleOpen = () => setOpenModal(true);
    // const handleClose = () => setOpenModal(false);

    React.useEffect(() => {
        if (kanban) {
            let arr = [];
            for (let x in lstCor) {
                if (x === 'common') continue;
                arr.push(x)
            }
            setTodas(arr);

            if (kanban.lstEtiqueta) {
                let arr = kanban.lstEtiqueta;
                // for (let x in cc) {
                //     const item = kanban.lstEtiqueta.find(e => e.nome === cc[x]);
                //     if (item) continue;
                //     arr.push({
                //         nome: cc[x],
                //         tom: 500,
                //     });
                // }
                setColors(arr);
                setChecked(cartao.lstEtiqueta ? cartao.lstEtiqueta : []);

            } else {
                let arr = [];
                for (let x in cc) {
                    arr.push({
                        nome: cc[x],
                        tom: 500,
                    });
                }
                setColors(arr);
            }
        }
    }, [kanban])

    const handleToggle = (value) => () => {
        const currentIndex = checked && checked.indexOf(value);
        const newChecked = [...checked];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }
        console.log(cartao, value, cartao.lstEtiqueta);

        console.log(newChecked);

        atualizaEtiquetaCard({
            id: cartao.id,
            lstEtiqueta: newChecked
        })

        setChecked(newChecked);
    };

    function handleEscolheCor(c) {
        setCor(c);
        console.log( c );
        // setCorEscolhida(c);
        setTitulo(c?c.titulo:'');
        setOpenModal(true);
    }

    function atualizaEtiquetaCard(dado){
        Service.POST('/api/security/projeto/kanban/salvaCardEtiqueta', dado).then(r => {
            console.log(r);
            if (r.success) {
                // setKanban( r.dado );
                setOpenModal(false);
                handleClose();
                action({
                    type: TYPES.etiqueta,
                    dado: r.dado
                });
            } else {
                alert(r.msg);
            }
        })
    }
    function handleSalvaEtiqueta() {
        console.log('>>>handleSalvaEtiqueta<<<')

        const dado = {
            id: kanban.id,
            idCartao: cartao.id,
            etiqueta: {
                id: cor.id,
                nome: cor.nome,
                tom: cor.tom,
                titulo: titulo
            }
        }
        console.log(dado)

        Service.POST('/api/security/projeto/kanban/salvaEtiqueta', dado).then(r => {
            console.log(r);
            if (r.success) {
                // setKanban( r.dado );
                setOpenModal(false);
                handleClose();
                action({
                    type: TYPES.etiqueta,
                    dado: r.dado
                });
            } else {
                alert(r.msg);
            }
        })
    }

    return (
        <Menu sx={{ width: 520, maxWidth: '100%' }}
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            slotProps={{
                paper: {
                    style: {
                        maxHeight: ITEM_HEIGHT * 10.5,
                        width: '30ch',
                    },
                },
                list: {
                    'aria-labelledby': 'long-button',
                },
            }}
            size='small'
        >
            <Typography variant="subtitle1" align="center">Etiquetas</Typography>
            {colors && colors.map((row, id) => {
                const cor = lstCor[row.nome];
                return (
                    <ListItem key={row.id ? row.id : id} dense
                        secondaryAction={
                            <IconButton edge="end" aria-label="comments" onClick={() => handleEscolheCor(row)}>
                                <Edit />
                            </IconButton>
                        }
                        disablePadding
                    >
                        <ListItemButton role={undefined} onClick={handleToggle(row.id ? row.id : id)} dense
                            sx={{
                                background: cor[row.tom],
                                '&:hover': {
                                    backgroundColor: cor[600], // Change background on hover
                                    color: cor[50], // Change text color on hover
                                },
                            }}
                        >
                            <ListItemIcon>
                                <Checkbox
                                    edge="start"
                                    checked={checked && checked.includes(row.id ? row.id : id)}
                                // tabIndex={-1}
                                // disableRipple
                                // inputProps={{ 'aria-labelledby': 0 }}
                                />
                            </ListItemIcon>
                            <ListItemText id={0} primary={row.titulo ? row.titulo : ''} />
                        </ListItemButton>
                    </ListItem>
                )
            })}
            <ListItem dense disablePadding >
                <ListItemButton role={undefined} dense onClick={() => handleEscolheCor()}>
                    <ListItemText id={0} primary='Nova Etiqueta' />
                </ListItemButton>
            </ListItem>
            <Modal
                open={openModal}
                onClose={() => setOpenModal(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Typography align={"center"} variant="h6" component="h2">
                        Editar etiqueta
                    </Typography>
                    {cor &&
                        // <ListItem disablePadding>
                        <div role={undefined}
                            style={{
                                width: '100%', height: 40,
                                background: lstCor[cor.nome][cor.tom]
                            }}
                        >
                            <ListItemText id={0} primary={cor.nome} />
                        </div>
                        // </ListItem>
                    }

                    <TextField label="Titulo" variant="standard" sx={{ m: 2 }} fullWidth
                        value={titulo} onChange={(e) => setTitulo(e.target.value)}
                    />
                    <Grid container spacing={2}>
                        <Grid size={6}>
                            <List
                                sx={{
                                    width: '100%',
                                    maxWidth: 360,
                                    bgcolor: 'background.paper',
                                    position: 'relative',
                                    overflow: 'auto',
                                    maxHeight: 300,
                                    '& ul': { padding: 0 },
                                }}
                                subheader={<li />}
                            >
                                {todas.map((c, id) => {
                                    const cor = lstCor[c];
                                    return (
                                        <ListItem key={id} disablePadding>
                                            <ListItemButton role={undefined} onClick={() => setCor({ nome: c, tom: 500 })}
                                                sx={{
                                                    background: cor[500],
                                                    '&:hover': {
                                                        backgroundColor: cor[600], // Change background on hover
                                                        color: cor[50], // Change text color on hover
                                                    },
                                                }}
                                            >
                                                <ListItemText id={0} primary={c} />
                                            </ListItemButton>
                                        </ListItem>)
                                }
                                )}
                            </List>
                        </Grid>
                        <Grid size={6}>
                            {cor && <List
                                sx={{
                                    width: '100%',
                                    maxWidth: 360,
                                    bgcolor: 'background.paper',
                                    position: 'relative',
                                    overflow: 'auto',
                                    maxHeight: 300,
                                    '& ul': { padding: 0 },
                                }}
                                subheader={<li />}
                            >
                                {[50, 100, 200, 300, 400, 500, 600, 700, 800, 900].map((index, id) => {
                                    const c = lstCor[cor.nome][index];
                                    return (
                                        <ListItem key={id} disablePadding>
                                            <ListItemButton role={undefined} onClick={() => setCor({id:cor.id, nome: cor.nome, tom: index })}
                                                sx={{
                                                    background: c
                                                }}
                                            >
                                                <ListItemText primary={index} />
                                            </ListItemButton>
                                        </ListItem>)
                                }
                                )}
                            </List>}
                        </Grid>
                    </Grid>
                    <Stack
                        direction="row"
                        spacing={2}
                        sx={{
                            justifyContent: "center",
                            mt: 4
                        }}>
                        <Button variant="outlined" onClick={handleSalvaEtiqueta}
                            disabled={!cor}
                        >
                            Salvar
                        </Button>
                        <Button variant="outlined"
                            disabled={!cor}
                        >Excluir</Button>
                    </Stack>
                </Box>
            </Modal>
        </Menu>
    );
}
